import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['checkbox','source'];

  clickCheckbox(event){
    this.sourceTargets.forEach(target => target.checked = event.target.checked);
  }
}
